<mat-dialog-content size="lg">
  <h1 class="font-semibold text-2xl pb-3">
    Actualizar Ítem
  </h1>
  <form [formGroup]="form" class="flex flex-col gap-6 p-3">
    @if (data) {

    <div class="flex flex-col gap-4">

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label for="id" class="text-gray-500">Código</label>
          <input id="id" type="text" formControlName="id" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['id'].invalid && (f['id'].touched || f['id'].dirty)}" />
        </div>
        <div>
          <label for="status" class="text-gray-500">Status</label>
          <input id="status" type="text" [disabled]="true" [value]="item?.active ?? true ? 'Activo' : 'Inactivo'"
            [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:cursor-not-allowed"
            [ngClass]="getBackgroundClasses(item?.active ?? true)" />
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label for="category" class="text-gray-500">Categoría</label>
          <input id="category" type="text" formControlName="category" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['category'].invalid && (f['category'].touched || f['category'].dirty)}" />
        </div>
        <div>
          <label for="productType" class="text-gray-500">Tipo de Producto</label>
          <input id="productType" type="text" formControlName="productType" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['productType'].invalid && (f['productType'].touched || f['productType'].dirty)}" />
        </div>
        <div>
          <label for="finish" class="text-gray-500">Acabado</label>
          <input id="finish" type="text" formControlName="finish" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['finish'].invalid && (f['finish'].touched || f['finish'].dirty)}" />
        </div>
      </div>

      <div>
        <label for="description" class="text-gray-500">Descripción</label>
        <textarea id="description" formControlName="description" [disabled]="true"
          class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
          [ngClass]="{'border-red-500':f['description'].invalid && (f['description'].touched || f['description'].dirty)}"></textarea>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-9 gap-4">
        <div class="md:col-span-2">
          <label for="dimensions" class="text-gray-500">Dimensiones</label>
          <input id="dimensions" type="text" formControlName="dimensions" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['dimensions'].invalid && (f['dimensions'].touched || f['dimensions'].dirty)}" />
        </div>
        <div class="md:col-span-3">
          <label for="color" class="text-gray-500">Color</label>
          <input id="color" type="text" formControlName="color" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['color'].invalid && (f['color'].touched || f['color'].dirty)}" />
        </div>
        <div class="md:col-span-3">
          <label for="texture" class="text-gray-500">Textura</label>
          <input id="texture" type="text" formControlName="texture" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['texture'].invalid && (f['texture'].touched || f['texture'].dirty)}" />
        </div>
        <div class="md:col-span-1">
          <label for="thickness" class="text-gray-500">Espesor</label>
          <input id="thickness" type="text" formControlName="thickness" [disabled]="true"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['thickness'].invalid && (f['thickness'].touched || f['thickness'].dirty)}" />
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-10 gap-4">
        <div class="md:col-span-2">
          <label for="platform" class="text-gray-500">Tarima</label>
          <input id="platform" type="number" min="0" step="1" formControlName="platform" (keydown)="onlyDigits($event)"
            (paste)="onPaste($event)"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['platform'].invalid && (f['platform'].touched || f['platform'].dirty)}" />
        </div>
        <div class="md:col-span-2">
          <label for="halfPlatform" class="text-gray-500">1/2</label>
          <input id="halfPlatform" type="number" min="0" step="1" formControlName="halfPlatform"
            (keydown)="onlyDigits($event)" (paste)="onPaste($event)"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['halfPlatform'].invalid && (f['halfPlatform'].touched || f['halfPlatform'].dirty)}" />
        </div>
        <div class="md:col-span-2">
          <label for="quarterPlatform" class="text-gray-500">1/4</label>
          <input id="quarterPlatform" type="number" min="0" step="1" formControlName="quarterPlatform"
            (keydown)="onlyDigits($event)" (paste)="onPaste($event)"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['quarterPlatform'].invalid && (f['quarterPlatform'].touched || f['quarterPlatform'].dirty)}" />
        </div>
        <div class="md:col-span-2">
          <label for="eighthPlatform" class="text-gray-500">Mínima</label>
          <input id="eighthPlatform" type="number" min="0" step="1" formControlName="eighthPlatform"
            (keydown)="onlyDigits($event)" (paste)="onPaste($event)"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['eighthPlatform'].invalid && (f['eighthPlatform'].touched || f['eighthPlatform'].dirty)}" />
        </div>
        <div class="md:col-span-2">
          <label for="leadTime" class="text-gray-500">Días de entrega</label>
          <input id="leadTime" type="number" min="0" step="1" formControlName="leadTime" (keydown)="onlyDigits($event)"
            (paste)="onPaste($event)"
            class="w-full py-4 p-2 border-1 rounded-2xl border-gray-400 focus:outline-none placeholder-gray-400 disabled:bg-gray-200 disabled:cursor-not-allowed"
            [ngClass]="{'border-red-500':f['leadTime'].invalid && (f['leadTime'].touched || f['leadTime'].dirty)}" />
        </div>
      </div>

    </div>

    }

  </form>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
    (click)="close(false)">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
  <button
    class="rounded-3xl flex items-center gap-2 bg-orange-500 text-white py-2 px-4 cursor-pointer hover:bg-orange-600 disabled:bg-orange-200 disabled:cursor-not-allowed"
    (click)="update()" [disabled]="form.invalid">
    <span class="text-base">Guardar</span>
    <i class="fi-rr-disk text-base flex"></i>
  </button>
</mat-dialog-actions>